import { render, staticRenderFns } from "./ABAddOrEditTextResult.vue?vue&type=template&id=af8c2248&scoped=true"
import script from "./ABAddOrEditTextResult.vue?vue&type=script&lang=js"
export * from "./ABAddOrEditTextResult.vue?vue&type=script&lang=js"
import style0 from "./ABAddOrEditTextResult.vue?vue&type=style&index=0&id=af8c2248&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8c2248",
  null
  
)

export default component.exports